import { Chart, ArcElement, DoughnutController } from 'chart.js'

const fn = {
  init: () => {
    Chart.register(ArcElement, DoughnutController)

    const els = document.querySelectorAll('.element-chart')

    els.forEach((el) => {
      const canvas = el.querySelector('canvas')
      const ctx = canvas.getContext('2d')
      const json = JSON.parse(canvas.dataset.json)

      new Chart(ctx, {
        type: 'doughnut',
        options: {
          events: [],
          cutout: '60%',
        },
        data: {
          datasets: [
            {
              data: json.data,
              backgroundColor: json.backgroundColor,
            },
          ],
        },
      })
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
